import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import { DealPreviewTemplate } from './DealPreviewTemplate';
import { SC } from '../../styles/theme';
import { rem } from 'polished';

export const DealPreviewStyled = styled(DealPreviewTemplate)<SC>`
    .overlay {
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        z-index: 25;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;

        .dialog {
            padding: ${rem(30)};
            background: white;
            padding: ${rem(30)};
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: ${rem(450)};
            text-align: center;

            .icon {
                width: ${rem(30)};
                height: ${rem(27)};
                padding: 0;
                margin: ${rem(20)};
            }

            h1 {
                font-size: ${rem(22)};
                text-transform: uppercase;
            }

            p {
                font-size: ${rem(12)};
            }

            .unavailableVehicleDescription {
                font-size: ${rem(12)};
            }

            .unavailableVehicleRedirect {
                padding-left: ${rem(5)};
                color: ${({ theme }) => theme.colors.primary};
                cursor: pointer;
            }
        }
    }
    .deal-expiration {
        margin-bottom: ${rem(6)};
        width: ${rem(288)};
        color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .deal {
        border: 2px solid ${({ theme }) => theme.colors.grey20};
        margin-bottom: ${rem(30)};
        max-width: ${rem(825)};
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;

        @media (max-width: ${breakpoints.md}px) {
            max-width: 90vw;
        }

        .deal-content {
            &__order-data {
                display: flex;
                justify-content: space-between;
                font-size: ${rem(12)};
                margin-bottom: ${rem(20)};
            }

            .car-preview {
                padding: ${rem(20)};

                img {
                    max-width: 100%;
                }

                .deal-expiration {
                    margin-bottom: 0;
                }
            }

            .car-header {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: ${rem(20)} ${rem(10)} ${rem(20)} ${rem(20)};

                @media (min-width: ${rem(500)}) {
                    flex-direction: row;
                    padding: ${rem(30)};
                }

                h2 {
                    font-size: ${rem(20)};
                }

                .price-and-date {
                    display: flex;
                    flex-direction: column;
                    min-width: ${rem(250)};

                    .date-container {
                        text-align: left;

                        @media (min-width: ${breakpoints.sm}px) {
                            text-align: right;
                        }

                        span {
                            .text {
                                font-size: ${({ theme }) => theme.fontSizes.textBase};
                                color: ${({ theme }) => theme.colors.grey1};
                                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                            }
                        }
                    }

                    .price-container {
                        min-height: ${rem(36)};
                        min-width: ${rem(20)};
                        justify-content: flex-end;
                        display: flex;

                        .price {
                            min-width: ${rem(100)};
                            font-size: ${rem(24)};
                            line-height: ${rem(24)};

                            .monthly-price-suffix {
                                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                            }

                            .currencyLabel {
                                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                            }

                            .price-value-b2c {
                                font-size: ${rem(12)};
                                color: ${({ theme }) => theme.colors.grey1};
                                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                                position: relative;
                                right: ${rem(8)};

                                span {
                                    color: ${({ theme }) => theme.colors.black1};
                                    font-size: ${rem(12)};
                                    font-weight: ${({ theme }) => theme.fontWeights.textMedium};
                                }

                                .currencyLabel {
                                    font-size: ${rem(12)} !important;
                                }
                            }

                            .big-price,
                            .cut-price {
                                display: flex;
                                flex-direction: row;

                                & > .suffix,
                                & > .price-value {
                                    min-width: fit-content;
                                }
                            }

                            .cut-price {
                                font-size: ${({ theme }) => theme.fontSizes.textMedium};

                                .price-value {
                                    position: relative;

                                    &::after {
                                        position: absolute;
                                        top: 0.5rem;
                                        right: 0;
                                        left: 0;
                                        content: '';
                                        height: 0.08rem;
                                        background: ${({ theme }) => theme.colors.red};
                                        transform: rotate(164deg);
                                    }
                                }
                            }
                        }

                        .date {
                            text-align: right;
                        }

                        .currencyLabel {
                            font-size: ${({ theme }) => theme.fontSizes.textMedium};
                        }
                    }

                    .date {
                        text-align: right;
                    }
                }
            }

            .date-clock-icon {
                position: relative;
                top: ${rem(4)};
            }

            .content {
                padding: ${rem(20)};
                display: flex;
                flex-direction: column;
                @media (min-width: ${breakpoints.md}px) {
                    flex-direction: row;
                }
            }

            .buttons {
                display: flex;
                justify-content: space-between;
                background: ${({ theme }) => theme.colors.white};
                flex-direction: row;
                width: 100%;

                &-ec41 {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 ${rem(20)} ${rem(20)};

                    @media (min-width: ${breakpoints.md}px) {
                        flex-direction: row;
                    }

                    .cta-button {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: ${rem(12)} ${rem(16)};
                        margin: 0;

                        + .cta-button {
                            margin-top: ${rem(8)};
                        }
                    }

                    .demand-offer {
                        color: ${({ theme }) => theme.colors.primary};
                        background: ${({ theme }) => theme.colors.white};
                        border-color: ${({ theme }) => theme.colors.primary};

                        &:hover {
                            color: ${({ theme }) => theme.colors.white};
                            background: ${({ theme }) => theme.colors.primary};
                        }
                    }

                    .my-saves-remove-save-button {
                        border: 0;
                        background: none;
                        color: ${({ theme }) => theme.colors.black};

                        .icon-wrapper,
                        svg {
                            height: ${rem(12)};
                        }

                        path {
                            fill: ${({ theme }) => theme.colors.primary};
                        }

                        @media (max-width: ${breakpoints.md}px) {
                            order: 1;
                            margin-top: ${rem(8)};
                        }
                        &:focus-visible,
                        &:hover {
                            color: ${({ theme }) => theme.colors.primary};
                        }
                    }
                }

                &-box {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    padding: ${rem(20)} ${rem(8)};

                    &-ec41 {
                        min-width: ${rem(300)};
                        display: flex;
                        flex-direction: column;
                    }

                    @media (min-width: ${breakpoints.sm}px) {
                        flex-direction: row;
                    }
                }

                button {
                    position: relative;
                    background: transparent;
                    color: ${({ theme }) => theme.colors.black};
                    text-decoration-line: underline;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100%;
                    margin: 0;
                    padding: ${rem(16)} ${rem(8)};

                    &.continue {
                        padding: ${rem(16)} ${rem(20)};
                        margin: ${rem(8)} ${rem(20)} ${rem(8)} 0;
                        background: ${({ theme }) => theme.colors.white};
                        order: 1;
                        color: ${({ theme }) => theme.colors.primary};
                        text-decoration: none;
                        border: ${rem('1px')} solid ${({ theme }) => theme.colors.primary};

                        @media (min-width: ${breakpoints.sm}px) {
                            order: initial;
                        }
                    }

                    .spinner {
                        position: absolute;
                    }
                }
            }
        }
    }

    .deal-steps-flow {
        margin: ${rem(20)} 0;
        position: relative;

        ul {
            li {
                z-index: 1;
            }

            @media (min-width: ${breakpoints.sm}px) {
                width: ${rem(240)};
            }

            &.timeline {
                min-height: ${rem(160)};

                @media (min-width: ${breakpoints.sm}px) {
                    min-width: ${rem(240)};
                }
                .step-container:last-child {
                    margin-bottom: 0;
                }

                &::before {
                    content: '';
                    position: absolute;
                    border-left: 2px dashed ${({ theme }) => theme.colors.grey4};
                    height: 100%;
                    top: 0;
                    left: ${rem(11)};
                }
            }
        }

        ul {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-between;
            padding: 0;
            margin: 0;
        }

        .step-container {
            list-style-type: none;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            z-index: 5;

            .icon {
                width: ${rem(25)};
                height: ${rem(25)};
                border-radius: 50%;
                display: inline-flex;
                align-items: center;
                justify-content: center;

                &.ok {
                    content: url('data:image/svg+xml;charset=UTF-8,<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.84467 11.4699L0.969661 6.5949C0.67678 6.30202 0.67678 5.82715 0.969661 5.53424L2.0303 4.47357C2.32318 4.18066 2.79808 4.18066 3.09096 4.47357L6.375 7.75758L13.409 0.723567C13.7019 0.430686 14.1768 0.430686 14.4697 0.723567L15.5303 1.78423C15.8232 2.07711 15.8232 2.55199 15.5303 2.8449L6.90533 11.4699C6.61242 11.7628 6.13755 11.7628 5.84467 11.4699Z" fill="white"/></svg>');
                    padding: ${rem(5)};
                }

                &.attention {
                    border-radius: 0;
                    background-color: white;
                    content: url('data:image/svg+xml;base64,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');
                    padding: 0;
                }

                &.none {
                    border: 3px solid ${({ theme }) => theme.colors.grey4};
                    background: white;
                }
            }

            .text {
                padding-left: ${rem(10)};
            }
        }
    }

    .priceWrap {
        background: transparent !important;

        @media (max-width: ${rem(500 - 0.1)}) {
            margin-left: ${rem(-5)};
            margin-top: ${rem(5)};
        }

        &--container {
            min-width: ${rem(320)};
        }
    }

    .price-and-date .date {
        padding-right: ${rem(10)};
    }

    .deal .deal-content .buttons .continue__large {
        display: none;

        @media (min-width: ${breakpoints.sm}px) {
            display: block;
        }
    }

    .deal .deal-content .continue__mobileXSOnly {
        margin: ${rem(5)} auto;
        width: 95%;
        display: block;

        @media (min-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .deal-saved-text {
        margin: ${rem(20)};
        width: ${rem(240)};
        color: ${({ theme }) => theme.colors.grey1};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        @media (min-width: ${breakpoints.sm}px) {
            margin-left: auto;
        }
    }

    .deal .deal-content .car-header .price-and-date .date {
        @media (max-width: ${rem(500 - 0.1)}) {
            text-align: left;
        }
    }

    .deal .deal-content .car-header .price-and-date .price-container {
        @media (max-width: ${rem(500 - 0.1)}) {
            justify-content: flex-start;
        }
    }

    .deal .deal-content .car-header .price-and-date .price-container .currencyLabel {
        @media (max-width: ${rem(500 - 0.1)}) {
            padding-left: 0;
        }
    }

    .details-link {
        background: none;
        cursor: pointer;
        border: none;
        border-bottom: 1px solid currentColor;
        transition: transform 0.15s ease-out;
        text-transform: uppercase;

        &:focus-visible {
            outline: none;
        }

        &:hover {
            transform: scale(1.1);
        }
    }

    .view-more {
        font-size: ${rem(14)};
        padding: ${rem(15)} ${rem(25)};
        background: ${({ theme }) => theme.colors._3000ShadesOfGrey};
    }

    .car-header .title {
        @media (min-width: ${rem(540)}) and (max-width: ${breakpoints.sm}px) {
            max-width: ${rem(225)};
        }

        @media (min-width: ${rem(500)}) and (max-width: ${rem(540 - 0.1)}) {
            max-width: ${rem(150)};
        }

        @media (min-width: ${breakpoints.sm}px) {
            width: 50%;
        }
    }

    .Collapsible {
        margin: ${rem(-2)} !important;
    }

    .continue.continue__mobile {
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};

        border: ${rem('1px')} solid ${({ theme }) => theme.colors.primary};
        padding: ${rem('12px')} ${rem('16px')};
        margin: 0 auto;
        display: block;
        width: 90%;

        @media (min-width: ${breakpoints.sm}px) {
            display: none;
        }
    }
`;
